import { SET_VIEWERS } from 'types/actions/viewers'

const viewersInitalState = {
  count: 0
}

export default (state = viewersInitalState, action) => {
  switch (action.type) {
    case SET_VIEWERS:
      delete action.type
      return {
        ...state,
        count: action.count
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/viewers.js